import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';

import * as settingsAction from "store/entities/settingsInfo/action";
import * as walletAction from 'store/entities/wallet/action';

import Table from 'components/__new/common/Table';
import useLoginInfo from 'hooks/useLoginInfo';
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import pen from "assets/images/icons/pen-icon.svg";
import SlideToggle from "components/__new/common/form/SlideToggle";
import ChangePasswordModal from 'components/__new/common/ChangePasswordModal';
import PinModal from "components/__new/common/PinModal";
import maskEmailAddress from 'utils/maskData';
import TwoFactorAuthModal from 'components/__new/common/TwoFactorAuthModal';
import * as accountActions from "store/auth/account/action";
import * as dashboardActions from "store/entities/dashboard/action";



const LoginAndSecurity = () => {
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    
    const { changeTwoFactorAuthStatus, resetTwoFactorAuthStatus, sendTransactionPinOtpLoading} = useSelector((state) => state.entities.settingsInfo);
    
    const { accessPin: selectorAccessPin, accessPinLoading } = useSelector((s) => s.entities.wallet);
    
    
    const { InlineRouterTab } = useInlinePageRouter();
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    // const [toggleActive, setToggleActive] = useState(false);
    const togglePasswordModal = () => {
        setShowPasswordModal(!showPasswordModal);
    }
    const [modalIndex, setModalIndex] = useState(null);
    const [enable2faIndex, setEnable2faIndex] = useState(0);
    const [initialAccessPin, setInitialAccessPin] = useState(0);
    const [accessPin, setAccessPin] = useState(0);
    const [isChangedPin, setIsChangedPin] = useState(false);
    const [isChangedPin2fa, setIsChangedPin2fa] = useState(false);
    const [isOpenAccessPin, setIsOpenAccessPin] = useState(false);
    const [show2fa, setShow2fa] = useState(false);
    const [show2faContent, setShow2faContent] = useState('2faConsent')
    
    const { employerInfoLoading, employerInfo } = useSelector((s) => s.auth.account);
    const {dashboard} = useSelector(state => state.entities.dashboard);
    
    
    
    const getEmployerInfo = useCallback(() => {
        if (!employerInfoLoading && (Object.keys(employerInfo).length === 0 || employerInfo.status !== "success")) {
            dispatch(accountActions.getEmployerInfo());
            dispatch(dashboardActions.getDashboard());
            
        }
    }, [dispatch, employerInfo, employerInfoLoading]);
    
    
    // const getEmployerInfo = () => {
    //     if(!employerInfoLoading && (Object.keys(employerInfo).length === 0 || employerInfo.status !== "success")){
    //         dispatch(accountActions.getEmployerInfo())
    //     }
    // }
    
    // useCallback(() => getEmployerInfo , [getEmployerInfo])
    
    const [active2fa, setActive2fa] = useState(null)
    
    
    const toggleAccessPin = () => {
        setIsOpenAccessPin(!isOpenAccessPin);
        setModalIndex(0)
    }
    
    const toggle2fa = () => {
        setShow2fa(!show2fa)
    };
    
    
    const handleChangePinSubmit = (pin) => { 
        if(modalIndex === 0){
            setInitialAccessPin(pin)
            setModalIndex(modalIndex + 1);
        } else if(modalIndex === 1){
            if(initialAccessPin === pin){
                setAccessPin(pin)
            dispatch(settingsAction.sendTransactionPinOtp(userInfo?.token, 'access-pin'))
                setModalIndex(modalIndex + 1);
        } else {
            toast.error("Invalid access pin")
            setInitialAccessPin(0)
            setAccessPin(0)
            setModalIndex(0)
        }
        } else if(modalIndex === 2){
            // dispatch(settingsAction.changeTransactionPin({accessPin: accessPin, otp: +pin}))
            dispatch(walletAction.createAccessPin(userInfo?.token, {accessPin: accessPin, otp: +pin}));
            setIsChangedPin(true);
            
        } else return null;
    }
    const handleCancelPinSubmit = () => { 
        setModalIndex(0);
    }
    
    
    const handle2faSubmit = (pin) => { 
        if(enable2faIndex === 0){
            setEnable2faIndex(enable2faIndex + 1);
            dispatch(settingsAction.sendTransactionPinOtp(userInfo?.token, 'two-fa'))
            // dispatch(settingsAction.sendTransactionPinOtp({userId: userInfo?.employer?._id, purpose: 'access-pin'}))
            setIsOpenAccessPin((prevState) => !prevState);
        } else if(enable2faIndex === 1){
            dispatch(settingsAction.changeTwoFactorAuthStatus({twoFactorAuth: true, otp: +pin}))
            setIsChangedPin2fa(true)
            
        } else return null;
    }
    

    
    
    const queryOptions = [
        {
            title: "Profile Information",
            path: "/settings/profile"
            
        },
        {
            title: "Company Details",
            path: "/settings/info"           
        },
        {
            title: "Teams",
            path: "/settings/team-management",
            
        },
        {
            title: "Role Management",
            path: "/settings/team-management/roles",
            
        },
        {
            title: "On-Demand Pay",
            path: "/settings/ondemand-pay",
            
        },
        {
            title: "Login & Security",
            path: "/settings/login-security",
           
        },
        // {
        //     title: "Notifications",
        //     path: "/settings/notifications",
           
        // },
    ]
    
    
     
    const renderPinModal = (modalIndex) => {
        switch(modalIndex) {
            case 0:
                return (
                    <PinModal 
                        isOpenPin={isOpenAccessPin}
                        setIsOpenPin={setIsOpenAccessPin}
                        title="Change Transaction Pin"
                        description="Set up a stronger access pin"
                        handleSubmit={handleChangePinSubmit}
                        handleCancel={handleCancelPinSubmit}
                    />
                );
            case 1:
                return (
                    <PinModal 
                        isOpenPin={isOpenAccessPin}
                        setIsOpenPin={setIsOpenAccessPin}
                        title="Confirm Transaction Pin"
                        description="Please re-enter your access pin"
                        handleSubmit={handleChangePinSubmit}
                        handleCancel={handleCancelPinSubmit}
                        loading={sendTransactionPinOtpLoading}
                    />
                );
            case 2:
                return (
                    <PinModal 
                        isOpenPin={isOpenAccessPin}
                        setIsOpenPin={setIsOpenAccessPin}
                        title="Enter OTP"
                        description={`Please enter the OTP sent to ${maskEmailAddress(userInfo?.member?.email)} to change your access pin`}
                        submit={handleChangePinSubmit}
                        handleCancel={handleCancelPinSubmit}
                        loading={accessPinLoading}
                    />
                );
            default:
                return null;
        }
    };
     
    /* useEffect(() => {
        if(isChangedPin && changeTransactionPin !== null){
            setIsOpenAccessPin(false);
            toast.success(changeTransactionPin?.message)
        }
        // eslint-disable-next-line
    }, [changeTransactionPin]); */
    
    
    useEffect(() => {
        if(isChangedPin && selectorAccessPin?.error === false) {
            setIsOpenAccessPin(false);
            toast.success(selectorAccessPin?.message);
            dispatch(walletAction.createAccessPinReset());
        }
    }, [selectorAccessPin]);
    
    useEffect(() => {
        getEmployerInfo()
        // setActive2fa(employerInfo?.data?.employer?.twoFactorAuth ? true : false)
        setActive2fa(dashboard?.member?.twoFactorAuth ? true : false)
        
    }, [employerInfo?.data?.employer?.twoFactorAuth, dashboard?.member?.twoFactorAuth, getEmployerInfo]);
    

    useEffect(() => {
        if(changeTwoFactorAuthStatus?.error === false) {
            toast(changeTwoFactorAuthStatus?.message)
            dispatch(dashboardActions.getDashboard())
            dispatch(settingsAction.resetTwoFactorAuthStatus())
            // setActive2fa(changeTwoFactorAuthStatus?.data?.twoFactorAuth)
        }
    //     // eslint-disable-next-line
    }, [changeTwoFactorAuthStatus]);
    
    
  return (
    <div>
        
        <DynamicHeadTag
            headerText="Login & Security | Settings"
            headerDescription="Manage your login and security settings here."
        />
            
        <div className="lg:flex">
            <div className="w-full lg:w-1/2">
                <div className="page-title text-ep-deep-dark">
                    Settings
                </div>
            </div>
            <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
        </div>


        <div className="mt-6 w-full">
            <InlineRouterTab
                items={queryOptions}
            />
        </div>
            


        <ChangePasswordModal
            isOpen={showPasswordModal}
            setIsOpen={setShowPasswordModal}
        />
        {renderPinModal(modalIndex)}
        {show2fa &&  <TwoFactorAuthModal 
                        isOpen2fa={show2fa}
                        setIsOpen2fa={setShow2fa}
                        show2faContent={show2faContent}
                        setShow2faContent={setShow2faContent}
                        subText={!active2fa ? 'Click “Continue” to set up two-factor authentication on your account' : 'Click "Continue" to remove two-factor authentication on your account'}
                        cautionText={!active2fa ? "Level up your account security with 2FA! Simply enable it, and we'll send a verification code to your email for every login." : 'Disabling Two-Factor Authentication (2FA) significantly reduces your account security, making it more vulnerable to unauthorised access. We strongly recommend keeping 2FA enabled to protect your sensitive information'}
                        handleSubmit={handle2faSubmit}
                        loading={sendTransactionPinOtpLoading}
                        active2fa={active2fa}
                        setActive2fa={setActive2fa}
                        getEmployerInfo={getEmployerInfo}
                
                    />}

        <div className="mt-6 p-4 sm:p-6 bg-white" style={{borderRadius: '12px'}}>
            
            <div className='font-bold text-ep-black' style={{fontSize: '18px', lineHeight: '28px'}}>Login & Security</div>
            <div className="p-6 mt-4 border border-gray-200 rounded-lg">
                <Table className="w-full mb-6">
                    <Table.Body>
                        <tr>
                            <td style={{border: '0px', color: '#1A202C', backgroundColor: 'transparent', width: "250px", fontSize: '16px', lineHeight: '18.24px', fontWeight: 500, paddingLeft: '0px' }} className="font-medium">Change Password</td>
                            <td style={{border: '0px', color: '#4A5564', backgroundColor: 'transparent', fontSize: '16px', lineHeight: '18.24px'}} className="">Set up a strong password for logging in</td>
                            <td style={{border: '0px', fontWeight: 500, backgroundColor: 'transparent', width: '100%', display: 'flex', justifyContent: "flex-end", paddingRight: "122px", fontSize: '16px', lineHeight: '21px'}} className="font-medium">
                                <button type="button" style={{ fontSize: '16px', fontWeight: 500, lineHeight: '21px' }} className="text-ep-primary underline flex" onClick={togglePasswordModal}><img src={pen} alt="pen-icon"/>Change Password</button>
                            </td>
                        </tr>
                    </Table.Body>
                </Table>

                <hr className='my-4 '/>

                <Table className="w-full mt-6 mb-6">
                    <Table.Body>
                        <tr>
                            <td style={{border: '0px', color: '#1A202C', backgroundColor: 'transparent', width: "250px", fontSize: '16px', lineHeight: '18.24px', paddingLeft: '0px', fontWeight: 500}} className="font-medium">Change Transaction Pin</td>
                            <td style={{border: '0px', color: '#4A5564', backgroundColor: 'transparent', fontSize: '16px', lineHeight: '18.24px'}} className="">Set up a pin for authorizing transactions</td>
                            <td style={{border: '0px', fontWeight: 500, backgroundColor: 'transparent', width: '100%', display: 'flex', justifyContent: "flex-end", paddingRight: "122px", fontSize: '16px', lineHeight: '21px'}} className="font-medium">
                                <button type="button" style={{ fontSize: '16px', fontWeight: 500, lineHeight: '21px' }} className="text-ep-primary underline flex" onClick={toggleAccessPin}><img src={pen} alt="pen-icon"/>Change Pin</button>
                            </td>
                        </tr>
                    </Table.Body>
                </Table>

                <hr className='my-4'/>

                <Table className="w-full mt-6">
                    <Table.Body>
                        <tr>
                            <td style={{border: '0px', color: '#1A202C', backgroundColor: 'transparent', width: "250px", fontSize: '16px', lineHeight: '18.24px', paddingLeft: '0px', fontWeight: 500}} className="font-medium">Two Factor Authentication</td>
                            <td style={{border: '0px', color: '#4A5564', backgroundColor: 'transparent', fontSize: '16px', lineHeight: '18.24px'}} className="">Add an extra layer of security</td>
                            <td style={{border: '0px', backgroundColor: 'transparent', width: '100%', display: 'flex', justifyContent: "flex-end", paddingRight: "122px", fontSize: '16px', lineHeight: '21px'}} className="invisible">spaceeeeeeeeeeeeeeeeeeeeeeee</td>
                        </tr>
                    </Table.Body>
                </Table>

                <div className="flex py-4 mt-4">
                    <SlideToggle 
                        onChange={toggle2fa}
                        active={active2fa}
                    /> 
                    <div className="font-medium text-ep-gray-700 pl-3" style={{fontSize: '16px', lineHeight: '18.24px'}}>Enable 2FA on Login</div>
                </div>
            </div>

            {/* Former view */}
            {/* <div className='border border-gray-200 p-5 rounded-md mt-5 pr-10'>
                <div className='flex justify-between items-center'>
                    <div className='font-medium'>Change Password</div>
                    <div className='text-ep-gray-600 ml-8'>Set up a strong password for logging in</div>
                    <div className='cursor-pointer'>
                        <div>
                            <button type="button" className="text-ep-primary underline flex pr-8" onClick={togglePasswordModal}><img src={pen} alt="pen-icon"/>Change Password</button>
                        </div>
                    </div>
                </div>
                
                <hr className='mt-8'/>
                
                <div className='flex justify-between items-center my-8'>
                    <div className='font-medium'>Change Transaction Pin</div>
                    <div className='text-ep-gray-600 mr-6'>Set up a pin for authorizing transactions</div>
                    <div className='cursor-pointer pl-7'>
                        <div>
                            <button type="button" className="text-ep-primary underline flex pr-8" onClick={toggleAccessPin}><img src={pen} alt="pen-icon"/>Change Pin</button>
                        </div>
                    </div>
                </div>
                
                <hr className='mt-8'/>
                
                <div className='flex justify-between items-center my-8'>
                    <div className='font-medium'>Two Factor Authentication</div>
                    <div className='text-ep-gray-600 mr-6'>Add an extra layer of security</div>
                    <div className='invisible'>spaceeeeeeeeeeeeeeeeeeeeeeee</div>
                </div>
                
                <div className="flex">
                  <SlideToggle 
                    onChange={toggle2fa}
                    active = {active2fa}
                    // whenActive={toggle2fa}
                    /> 
                    <div className='font-medium text-ep-gray-700 pl-3'>Enable 2FA on Login</div>
                </div>                 
            </div> */}
        </div>
        
    </div>
  )
}

export default LoginAndSecurity
